import { axios } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { PaginatedResults } from "@sdk/utils/paginated-results";
import type { iBookingActivityLog } from "@sdk/bookings/booking-activity-log-model";

export class BookingActivityLogsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.bookingActivityLogs.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.bookingActivityLogs = {
      configure: (cfg: { basePath?: string; token?: string }) => {
        Object.assign(this.config, cfg);
      },
      getByBookingId: async (
        bookingId: string,
        params: { page?: number; limit?: number } = {}
      ): Promise<PaginatedResults<iBookingActivityLog>> => {
        const page = Math.max(1, Number(params.page) || 1);
        const limit = Math.min(Math.max(1, Number(params.limit) || 20), 100);
        const search = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });
        const results = await axios.get(
          this.config.basePath +
            `/bookings/${bookingId}/activity-logs?${search}`,
          { headers: { Authorization: this.config.token } }
        );
        return results.data;
      },
      addEntry: async (
        bookingId: string,
        body: {
          activityType: string;
          text: string;
          data?: { previousValue?: unknown; newValue?: unknown };
        }
      ): Promise<iBookingActivityLog> => {
        const results = await axios.post(
          this.config.basePath + `/bookings/${bookingId}/activity-logs`,
          body,
          { headers: { Authorization: this.config.token } }
        );
        return results.data;
      },
    };
    this.bookingActivityLogs.configure(config);
  }

  bookingActivityLogs!: {
    configure: (config: { basePath?: string; token?: string }) => void;
    getByBookingId: (
      bookingId: string,
      params?: { page?: number; limit?: number }
    ) => Promise<PaginatedResults<iBookingActivityLog>>;
    addEntry: (
      bookingId: string,
      body: {
        activityType: string;
        text: string;
        data?: { previousValue?: unknown; newValue?: unknown };
      }
    ) => Promise<iBookingActivityLog>;
  };
}

export const bookingActivityLogsServices = new BookingActivityLogsServices(
  SDKConfig
);
